import { formatPhoneNumber } from '@mybonum/utils';
import { TableColumnType, Typography } from 'antd';

import { TAdminAppointmentType } from '../types.ts';

export const useColumns = (): TableColumnType<TAdminAppointmentType>[] => {
    return [
        {
            width: 70,
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
        },
        {
            width: 160,
            key: 'firstName',
            title: 'First Name',
            dataIndex: 'firstName',
            render: (_, record) => record.firstName || '-',
        },
        {
            width: 160,
            key: 'lastName',
            title: 'Last Name',
            dataIndex: 'lastName',
            render: (_, record) => record.lastName || '-',
        },
        {
            width: 260,
            key: 'email',
            title: 'Email',
            dataIndex: 'email',
            render: (_, record) =>
                record.email ? (
                    <Typography.Link href={`mailto:${record.email}`}>
                        {record.email}
                    </Typography.Link>
                ) : (
                    '-'
                ),
        },
        {
            width: 190,
            key: 'phone',
            title: 'Phone',
            dataIndex: 'phone',
            render: (_, record) =>
                record.phone ? (
                    <Typography.Link href={`tel:${record.phone}`}>
                        {formatPhoneNumber(record.phone)}
                    </Typography.Link>
                ) : (
                    '-'
                ),
        },
        {
            width: 300,
            key: 'practiceName',
            title: 'Practice Location Name',
            dataIndex: 'practiceName',
            render: (_, record) => record.practiceName || '-',
        },
        {
            width: 260,
            key: 'practiceEmail',
            title: 'Practice Location Email',
            dataIndex: 'practiceEmail',
            render: (_, record) =>
                record.practiceEmail ? (
                    <Typography.Link href={`mailto:${record.practiceEmail}`}>
                        {record.practiceEmail}
                    </Typography.Link>
                ) : (
                    '-'
                ),
        },
    ];
};
